import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Signin() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box height="100vh" width="100vw" bgcolor="#9E9CA4" pt="10%">
      <Card sx={{ maxWidth: { xs: "95%", md: "35%" }, mx: "auto" }}>
        <CardContent>
          <Typography variant="h5">{t("signin.signUpLogIn")}</Typography>
          <Typography>{t("signin.signInForOffers")}</Typography>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={6}>
              <TextField fullWidth label={t("signin.firstName")} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label={t("signin.lastName")} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label={t("signin.enterEmailOrPhone")} />
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth variant="contained" color="primary">
                {t("signin.next")}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={() => navigate("/location")}
                fullWidth
                variant="text"
                color="primary"
              >
                {t("signin.useGuestLogin")}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Signin;
